import { AsyncPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, input, signal } from '@angular/core';

import { Observable } from 'rxjs';

import { CardComponent, CardContentComponent, EmptyComponent, ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { User } from '../../services/dto/user';
import { CamUsersService } from '../../services/users.service';
import { CamTranslationUser } from '../../translation.service';
import { UserProfileComponent } from './profile/user-profile.component';

@Component({
  selector: 'cam-user-profile-card',
  templateUrl: './user-profile-card.component.html',
  styleUrls: ['./user-profile-card.component.scss'],
  imports: [
    AsyncPipe,
    LoaderComponent,
    ErrorComponent,
    EmptyComponent,
    CardComponent,
    CardContentComponent,
    UserProfileComponent,
  ],
})
export class UserProfileCardComponent extends CamBaseComponent {
  userId = input('');

  private _usersService = inject(CamUsersService);

  public readonly user$ = signal<Observable<User | null> | null>(null);

  constructor() {
    super();
    CamTranslationUser.getInstance();
  }

  ngOnInit() {
    this._fetch();
    this.user$.set(this._usersService.user.get$(this.userId()));
  }

  public getUserLogoData(user: User) {
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      trigram: user.trigram,
      picture: user.picture,
    };
  }

  private _fetch() {
    this.requestState.asked();
    this._usersService.fetchUser$(this.userId()).subscribe({
      complete: () => this.requestState.completed(),
      error: (error: HttpErrorResponse) => {
        this.requestState.onError(error.status, error.statusText);
      },
    });
  }
}
